import { produce } from 'immer';
import { ADD_FRIEND_TO_ALL_FROM_INBOUND, CLEAR_ACTIVE_CONTACTS, HIDE_FRIEND_REQUEST_FROM_INBOUND, REMOVE_FRIEND_FROM_ALL_FROM_INBOUND, SET_ACTIVE_CONTACTS_FROM_INBOUND, SET_ALL_FRIENDS_FROM_INBOUND, SET_CONTACT_ACTIVE_FROM_INBOUND, SET_CONTACT_INACTIVE_FROM_INBOUND, SHOW_FRIEND_REQUEST_FROM_INBOUND } from '../actions/contactsActions';
const initialState = {
    activeContacts: null,
    allFriends: []
};
function addActiveContactToDraft(draft, type, playerId, username) {
    if (!draft.activeContacts) {
        draft.activeContacts = {};
    }
    if (!draft.activeContacts[type]) {
        draft.activeContacts[type] = [];
    }
    const existingActiveContact = (draft.activeContacts[type] || []).find((activeContact) => activeContact.playerId === playerId);
    if (existingActiveContact) {
        // Not sure what scenario will lead to getting a 'friend active' message when that friend is already 'active',
        // but we can update it in case the name changed and prevent adding it twice:
        existingActiveContact.playerId = playerId;
        existingActiveContact.username = username;
    }
    else {
        const activeContactsInType = draft.activeContacts[type];
        if (activeContactsInType) {
            activeContactsInType.push({
                activeContactType: type,
                playerId,
                username,
                idleString: ''
            });
        }
    }
}
function removeActiveContactFromDraft(draft, types, playerId) {
    types.forEach((type) => {
        if (draft.activeContacts && draft.activeContacts[type]) {
            draft.activeContacts[type] = (draft.activeContacts[type] || []).filter((activeContact) => activeContact.playerId !== playerId);
        }
    });
}
function getSortedAllFriends(allFriends) {
    const allFriendsSorted = [...allFriends];
    // sort alphabetically:
    allFriendsSorted.sort((friend1, friend2) => (friend1.name < friend2.name ? -1 : 1));
    return allFriendsSorted;
}
const contactsReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_ACTIVE_CONTACTS: {
                draft.activeContacts = null;
                break;
            }
            case SET_ALL_FRIENDS_FROM_INBOUND: {
                draft.allFriends = getSortedAllFriends(action.payload.allFriends);
                break;
            }
            case SET_ACTIVE_CONTACTS_FROM_INBOUND: {
                draft.activeContacts = action.payload.activeContacts;
                break;
            }
            case SET_CONTACT_ACTIVE_FROM_INBOUND: {
                action.payload.activeContactTypes.forEach((activeContactType) => {
                    addActiveContactToDraft(draft, activeContactType, action.payload.playerIdName.id, action.payload.playerIdName.name);
                });
                break;
            }
            case SET_CONTACT_INACTIVE_FROM_INBOUND: {
                removeActiveContactFromDraft(draft, action.payload.activeContactTypes, action.payload.playerId);
                break;
            }
            case SHOW_FRIEND_REQUEST_FROM_INBOUND: {
                addActiveContactToDraft(draft, action.payload.activeContactType, action.payload.playerIdName.id, action.payload.playerIdName.name);
                break;
            }
            case HIDE_FRIEND_REQUEST_FROM_INBOUND: {
                removeActiveContactFromDraft(draft, ['requests_received', 'requests_sent'], action.payload.playerId);
                break;
            }
            case ADD_FRIEND_TO_ALL_FROM_INBOUND: {
                // make sure the friend isn't already tracked:
                const { id, name } = action.payload;
                if (!draft.allFriends.find((friend) => friend.id === id)) {
                    draft.allFriends.push({ id, name });
                    // re-sort:
                    draft.allFriends = getSortedAllFriends(draft.allFriends);
                }
                break;
            }
            case REMOVE_FRIEND_FROM_ALL_FROM_INBOUND: {
                const { id } = action.payload;
                draft.allFriends = draft.allFriends.filter((friend) => friend.id !== id);
                break;
            }
        }
    });
};
export default contactsReducer;
